module.exports = __webpack_public_path__ + "static/media/jpmc.0c23bb97.png";